<template>
  <div>
    <LandHomeBanner></LandHomeBanner>
    <LandHomeValue></LandHomeValue>
    <LandHomeSolution></LandHomeSolution>
    <LandHomePartner></LandHomePartner>
    <LandHomePurchase></LandHomePurchase>
  </div>

</template>

<script>
import LandHomeBanner from './components/LandHomeBanner.vue'
import LandHomeValue from './components/LandHomeValue.vue'
import LandHomeSolution from './components/LandHomeSolution.vue'
import LandHomePartner from './components/LandHomePartner.vue'
import LandHomePurchase from './components/LandHomePurchase.vue'
export default {
  name: 'landHome',
  created () { },
  components: {
    LandHomeBanner,
    LandHomeValue,
    LandHomePurchase,
    LandHomeSolution,
    LandHomePartner
  },
  data () {
    return {
    }
  },
  props: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
